import React from 'react';
import {setGetAmountReferrals} from '../../store/thunk/setGetAmountReferrals';
import {useDispatch, useSelector} from 'react-redux';
import {setGetReferrals} from '../../store/thunk/setGetReferrals';
import TableCasino from '../../components/table';
import {setPostBonusesCreate} from '../../store/thunk/setPostBonusesCreate';
import Dialog from '@material-ui/core/Dialog';
import Title from '../../../../../@casino/ui/title';
import {columns, getRows} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0,
        color: '#fff'
    },
    wrap: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
        display: 'flex',
    },
    create: {
        padding: 10, 
        background: '#ffc324', 
        borderRadius: 4, 
        cursor: 'pointer', 
        color: '#141b33'
    },
    change: {
        padding: 10, 
        background: '#ffc324', 
        borderRadius: 4, 
        cursor: 'pointer', 
        color: '#141b33'
    },
    mt10: {
        marginTop: 10
    },
    mr12: {
        marginRight: 12
    },
    wrapBlock: {
        display: 'flex',
        flexDirection: 'column'
    },
    wrapLabel: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%', 
        alignItems: 'center'
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    wrapDialog: {
        width: 250, 
        height: 250, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleDialog: {
        fontSize: 16, 
        textAlign: 'center'
    },
    labelTitle: {
        fontFamily: 'Calibri, sans-serif', 
        color: '#2f2f2f'
    },
    inputStyle: {
        fontFamily: 'Calibri, sans-serif',
        width: 215,
        overflow: 'hidden',
        border: '1px solid rgb(229, 229, 229)',
        borderRadius: 4,
        padding: '14px 20px 13px 10px',
        fontSize: '16px',
        lineHeight: '16px',
        height: 16,
        outline: 'none',
    },
    createBtn: {
        border: 'none',
        background: 'rgb(255, 206, 1)',
        borderRadius: 4,
        marginTop: 12,
        padding: 10
    },
    rootFilter: {
        padding: 20, 
        paddingTop: 0
    },
    wrapBlockFilter: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    searchGamerFilter: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
}))

const ReferralsList = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetAmountReferrals());
        dispatch(setGetReferrals({
            page: 1,
            rowsPerPage: 10,
            search
        }))
    }, []);
    
    const amount = useSelector(state => state.referrals.amount);
    const [amountReferral, setAmountReferrral] = React.useState();
    const [openModal, setOpenModal] = React.useState(false);
    const [reward, setReward] = React.useState();
    const referrals = useSelector(state => state.referrals.list);
    const rows = React.useMemo(() => getRows(referrals.data), [referrals]);


    return (
        <div className={classes.root}>
            <Title label="Управление рефералами" />
            <div 
                className={classes.wrap}
                style={{
                    justifyContent: !amount.amount && !amount.referrer_amount ? 'flex-end' : 'space-between',
                }}
            >
                {
                    !amount.amount && !amount.referrer_amount &&
                    <>
                        <label htmlFor="reward">
                            <span 
                                className={classes.create}
                                onClick={() => {
                                    setOpenModal(true); 
                                }}
                            >
                                Создать
                            </span>
                        </label> 
                    </>
                    
                }
                {
                    !!amount.amount && !!amount.referrer_amount &&
                    <label htmlFor="bonus" className={classes.wrapLabel}>
                        <div className={classes.wrapBlock}>
                            <span className={classes.mr12}>Бонус для реферала в %: {amount.amount}</span>
                            <span className={classes.mr12}>Вознаграждение игроку: {amount.referrer_amount}</span>
                        </div>
                        
                        <div className={classes.mt10}>
                            <span 
                                className={classes.change}
                                onClick={() => setOpenModal(true)}
                            >Изменить</span>
                        </div>
                        
                    </label>
                }
            </div>
            <div className={classes.wrapBlockFilter} style={{padding: 0}}>
                <label htmlFor="search">
                    <input 
                        type="text" 
                        name="search" 
                        id="search" 
                        value={search} 
                        onChange={(v) => {
                            dispatch(setGetReferrals({
                                page: 1,
                                rowsPerPage: 10,
                                search: v.target.value
                            }))
                            setSearch(v.target.value)
                        }} 
                        className={classes.searchGamerFilter}
                        placeholder="Поиск по промокоду"
                    />
                </label>
            </div>
            <div className={classes.wrapTable}>
                <TableCasino 
                    route="/traffic/referral/"
                    pagination
                    allPage={referrals.countPage}
                    search={search}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetReferrals({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        search
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetReferrals({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        search
                    }))}
                />
            </div>
            <Dialog onClose={() => {setOpenModal(false); setReward(0); setAmountReferrral(0)}} open={openModal}>
                <div className={classes.wrapDialog}>
                    <h3 className={classes.titleDialog}>Реферальный бонус</h3>
                    <label htmlFor="bonus" className={classes.wrapBlock}>
                        <span className={classes.labelTitle}>Бонус для реферала в %</span>
                            <input 
                                type="text" 
                                id="bonus"
                                name="bonus" 
                                value={amountReferral} 
                                onChange={(v) => setAmountReferrral(+v.target.value)} 
                                className={classes.inputStyle}    
                            />
                    </label>
                        <label htmlFor="reward"  className={classes.wrapBlock}>
                            <span className={classes.labelTitle}>Вознаграждение</span>
                            <input 
                                type="text" 
                                id="reward" 
                                name="reward" 
                                value={reward} 
                                onChange={(v) => setReward(+v.target.value)}  
                                className={classes.inputStyle}
                            />
                            <button onClick={() => {
                                dispatch(setPostBonusesCreate({
                                    price: amountReferral, 
                                    referrer_amount: reward
                                }));
                                dispatch(setGetAmountReferrals());
                                setOpenModal(false); 
                            }}
                                className={classes.createBtn}
                            >Создать</button>
                        </label> 
                </div>
            </Dialog>
        </div>
    )
}

export default ReferralsList;